import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=51d4d2cb&scoped=true&lang=pug&"
import script from "./HelloWorld.vue?vue&type=script&lang=js&"
export * from "./HelloWorld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d4d2cb",
  null
  
)

export default component.exports